import { LeftNavResizeProvider } from '@ms/yammer-web-core-ui/dist/components/AppLayout';
import type { FC, PropsWithChildren } from 'react';
import React, { useMemo } from 'react';

import { useIsLeftNavCollapsedActive } from '../store';

import { readPersistedInitialWidth } from './internals/persistedLeftNavWidth';

// Rendered while the resizable nav chunk loads. It reads the persisted width synchronously and
// supplies it through the same context the mounted nav uses, so the nav paints at the persisted
// width on cold load instead of flashing the default responsive width and shifting layout.
export const ResizableLeftNavFallback: FC<PropsWithChildren> = ({ children }) => {
  const isCollapsedActive = useIsLeftNavCollapsedActive();
  const persistedWidth = useMemo(() => readPersistedInitialWidth(), []);
  const overrideWidth = isCollapsedActive ? null : persistedWidth;

  const value = useMemo(() => ({ overrideWidth, isWidthTransitionActive: false }), [overrideWidth]);

  return <LeftNavResizeProvider value={value}>{children}</LeftNavResizeProvider>;
};
